/** Phase 1 message files, one per task so parallel builders never share a file. */
import { c1EnGB } from './c1.js';
import { s1EnGB } from './s1.js';
import { s2EnGB } from './s2.js';
import { s3EnGB } from './s3.js';
import { s4EnGB } from './s4.js';
import { s5EnGB } from './s5.js';
import { s6EnGB } from './s6.js';
import { s7EnGB } from './s7.js';
import { s8EnGB } from './s8.js';
import { s9EnGB } from './s9.js';
import { w0EnGB } from './w0.js';
import { w1EnGB } from './w1.js';
import { w2EnGB } from './w2.js';
import { w3EnGB } from './w3.js';
import { w4EnGB } from './w4.js';
import { w5EnGB } from './w5.js';
import { w6EnGB } from './w6.js';
import { w7EnGB } from './w7.js';
import { w8EnGB } from './w8.js';
import { k1EnGB } from './k1.js';
import { k2EnGB } from './k2.js';
import { k3EnGB } from './k3.js';
export const phase1EnGB = {
    ...c1EnGB,
    ...s1EnGB,
    ...s2EnGB,
    ...s3EnGB,
    ...s4EnGB,
    ...s5EnGB,
    ...s6EnGB,
    ...s7EnGB,
    ...s8EnGB,
    ...s9EnGB,
    ...w0EnGB,
    ...w1EnGB,
    ...w2EnGB,
    ...w3EnGB,
    ...w4EnGB,
    ...w5EnGB,
    ...w6EnGB,
    ...w7EnGB,
    ...w8EnGB,
    ...k1EnGB,
    ...k2EnGB,
    ...k3EnGB,
};
//# sourceMappingURL=index.js.map